import * as React from 'react'

import { Button, type IllustrationType } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

interface Props {
  onCancel: () => void
  onConfirm: () => void
  title: string
  description?: string
  cancelText?: string
  confirmText?: string
  illustration?: IllustrationType
}

const ConfirmModal = ({
  title,
  description,
  cancelText,
  confirmText,
  onCancel,
  onConfirm,
  illustration,
}: Props) => {
  return (
    <Modal
      illustration={illustration ?? 'document-edit'}
      title={title}
      description={
        description ?? i18n.t('payroll_bundle.import_supplements.back_modal.description')
      }
      onClose={onCancel}
      onSubmit={onConfirm}
      footer={
        <>
          <Button type="secondary" onClick={onCancel}>
            {cancelText ?? i18n.t('payroll_bundle.import_supplements.back_modal.cancel')}
          </Button>
          <Button submit>
            {confirmText ?? i18n.t('payroll_bundle.import_supplements.back_modal.confirm')}
          </Button>
        </>
      }
    />
  )
}

export default ConfirmModal
